
import {
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  Ref,
  ref,
  watch,
} from "vue";
import { HubConnectionBuilder } from "@aspnet/signalr";
import $API from "@/services";
import router from "@/router";
import { ITextChat } from "@/models/textChat";
import { useStore } from "@/store";
import Card from "primevue/card";
import Button from "primevue/button";
import { splitDatetimeStringToString } from "@/utils/date-format";

interface IGroupUser {
  UserId: string;
  UserName: string;
  PersonName: string;
  isMine?: boolean;
}

interface IGroupChanged extends IGroupUser {
  Status: string;
}

export default defineComponent({
  name: "Chat Room",

  setup() {
    const state = reactive({
      id: router.currentRoute.value.params.id,
      roomName: "CASE_" + router.currentRoute.value.params.id,
      visibility: false,
    });

    watch(
      () => state.visibility,
      (n) => {
        if (n) {
          setTimeout(() => {
            scrollBottom();
          }, 10);
        }
      }
    );

    const store = useStore();

    const messages = reactive({
      participant: [] as Array<IGroupUser>,
      fullMessages: [] as Array<ITextChat>,
      filterMessages: [] as Array<ITextChat>,
    });

    const newMessage = ref("");
    const messageViewer$: Ref<HTMLDivElement | null> = ref(null);

    const connection = new HubConnectionBuilder()
      .withUrl(`${$API.BaseURL}/textChatHub`)
      .build();

    const loadLatestMessages = async () => {
      try {
        messages.fullMessages = (await $API.TextChatService.getLastMessage(state.roomName))?.Messages;
        setMessageFilter();
      } catch(ex) {
        console.warn(ex);
      }
    };

    const scrollBottom = () => {
      if (!messageViewer$.value) return;

      (messageViewer$.value as HTMLDivElement).scrollTo({
        top: messageViewer$.value.scrollHeight,
        behavior: "smooth",
      });
    };

    const setUsers = () => {
      messages.participant.forEach((user) => {
        user.isMine = user.UserName === store.getters.getAccountInfo?.UserName;
      });
    };

    const setMessageFilter = () => {
      messages.fullMessages.forEach((message) => {
        message.isMine =
          message.UserName === store.getters.getAccountInfo?.UserName;
      });

      // messages.filterMessages = messages.fullMessages.filter((message) => {
      //   return messages.participant.find((x) => {
      //     return x.UserName === message.UserName;
      //   });
      // });
      messages.filterMessages = messages.fullMessages;
    };

    const start = async () => {
      await connection.start();
      await connection.send("addToGroup", state.roomName);
      await connection.send("getGroupUsers", state.roomName);
    };
    onMounted(async () => {
      //수신
      connection.on("receivedMessage", async () => {
        await loadLatestMessages();
        scrollBottom();
      });
      // 그룹정보 수정: 사용자 등록 및 떠남
      connection.on("changedGroup", (data: string) => {
        const data2: IGroupChanged = JSON.parse(data) as IGroupChanged;
        if (data2.Status === "joined") {
          messages.participant = [...messages.participant, data2];
        } else if (data2.Status === "left") {
          const removeUser = messages.participant.find(
            (user) => user.UserName === data2.UserName
          );
          messages.participant = messages.participant.filter(
            (user) => user.UserName !== removeUser?.UserName
          );
        }
        setMessageFilter();
      });
      //그룹 사용자 정보 수신
      connection.on("receivedGroupUsers", (data: string) => {
        console.log(data, "receivedGroupUsers");
        const users: IGroupUser[] = JSON.parse(data) as IGroupUser[];
        messages.participant = [...users];
        setUsers();
      });

      await start();
      await loadLatestMessages();
      scrollBottom();
    });
    onUnmounted(async () => {
      if (connection) await connection.stop();
    });

    const toggleChat = () => {
      state.visibility = !state.visibility;
    };

    const sendMessage = async (e: Event) => {
      e.preventDefault();
      if (newMessage.value.trim() === "") return;
      await connection.send("newMessage", state.roomName, newMessage.value);
      newMessage.value = "";
      await loadLatestMessages();
      scrollBottom();
    };

    return {
      state,
      toggleChat,
      messages,
      newMessage,
      sendMessage,
      messageViewer$,
      splitDatetimeStringToString,
    };
  },
  components: {
    Card,
    Button,
  },
});
